// Google Ads conversion event helper — centralises all label wiring so
// swapping/adding conversions doesn't touch each React handler.
//
// Base gtag script lives in /app/frontend/public/index.html.
// Fill in the 4 labels below once you copy them from the "Event snippet"
// section of each conversion action in Google Ads.

// Conversion ID is the same for every action in the account.
export const GADS_CONVERSION_ID = "AW-18299458662";

// Labels are the part after the `/` in send_to. Verified against Google Ads
// event snippets on Feb 11, 2026.
//
// The Resume Studio label can be overridden at build time via the env var
// REACT_APP_GADS_LABEL_RESUME_STUDIO — so once you create the conversion
// action in Google Ads, drop the label string into /app/frontend/.env and
// restart the frontend. No code change needed.
export const GADS_LABELS = {
    candidate_signup: "rGRXCJebk88cEOao7pVE",
    recruiter_signup: "wBmBCJqbk88cEOao7pVE",
    job_application:  "vB8ICPr8lc8cEOao7pVE",
    contact_request:  "1rm1CIrEk88cEOao7pVE",
    resume_studio_purchase:
        process.env.REACT_APP_GADS_LABEL_RESUME_STUDIO || "PLACEHOLDER_RESUME_STUDIO",
};

/**
 * Fire a Google Ads conversion event.
 * @param {"candidate_signup"|"recruiter_signup"|"job_application"|"contact_request"|"resume_studio_purchase"} kind
 * @param {object} [opts] optional { value, currency, transaction_id } for value-based bidding
 */
export function fireGadsConversion(kind, opts = {}) {
    const label = GADS_LABELS[kind];
    if (!label || /^PLACEHOLDER/.test(label)) {
        // Placeholder — don't spam network. Once labels are set, this fires.
        if (typeof console !== "undefined") {
            console.debug("[gads] label not set for", kind, "opts:", opts);
        }
        return;
    }
    if (typeof window === "undefined" || typeof window.gtag !== "function") {
        return; // gtag not loaded (e.g., blocked by adblock — silent fail)
    }
    const params = { send_to: `${GADS_CONVERSION_ID}/${label}` };
    if (opts.value != null) params.value = opts.value;
    if (opts.currency) params.currency = opts.currency;
    if (opts.transaction_id) params.transaction_id = opts.transaction_id;
    window.gtag("event", "conversion", params);
}
